import { render, staticRenderFns } from "./DateTimeView.vue?vue&type=template&id=23097640"
import script from "./DateTimeView.vue?vue&type=script&lang=js"
export * from "./DateTimeView.vue?vue&type=script&lang=js"
import style0 from "./DateTimeView.vue?vue&type=style&index=0&id=23097640&prod&lang=scss&scopped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports